module.exports = __webpack_public_path__ + "img/pantalla6-4.8fcca966.png";